import { Directive, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ProposalService } from 'src/app/_services/proposal.service';
import { BusinessHealthMetadata } from 'src/app/_types/lead.types';
import { getBusinessCoverageDurationDaysLabel } from 'src/app/enums/business/business-coverage-duration-days.enum';
import { getBusinessHealthCoverageSystemLabel } from 'src/app/enums/business/business-health-coverage-system.enum';
import { getBusinessHealthCoverageWaitingDelayLabel } from 'src/app/enums/business/business-health-coverage-waiting-delay.enum';
import { getBusinessInsuredSalaryRateLabel } from 'src/app/enums/business/business-insured-salary-rate.enum';
import { getBusinessInvalidityDurationLabel } from 'src/app/enums/business/business-invalidity-duration.enum';
import { getBusinessMaternityCoverageLabel } from 'src/app/enums/business/business-maternity-coverage.enum';
import { getBusinessMaternityCoverageDurationLabel } from 'src/app/enums/business/business-maternity-coverage-duration.enum';
import { getBusinessWaitingDaysLabel } from 'src/app/enums/business/business-waiting-days.enum';
import { getPaymentFrequencyLabel } from 'src/app/enums/payment-frequency.enum';
import { getBooleanLabel } from 'src/app/helpers/utils';

import { BaseMetadataComponent } from '../../base-metadata.component';

@Directive()
export abstract class BusinessHealthMetadataComponentAbstract extends BaseMetadataComponent<BusinessHealthMetadata> {
  getBooleanLabel = getBooleanLabel;

  getPaymentFrequencyLabel = getPaymentFrequencyLabel;

  getBusinessWaitingDaysLabel = getBusinessWaitingDaysLabel;

  getBusinessInsuredSalaryRateLabel = getBusinessInsuredSalaryRateLabel;

  getBusinessCoverageDurationDaysLabel = getBusinessCoverageDurationDaysLabel;

  getBusinessHealthCoverageSystemLabel = getBusinessHealthCoverageSystemLabel;

  getBusinessInvalidityDurationLabel = getBusinessInvalidityDurationLabel;

  getBusinessMaternityCoverageDurationLabel =
    getBusinessMaternityCoverageDurationLabel;

  getBusinessMaternityCoverageLabel = getBusinessMaternityCoverageLabel;

  getBusinessHealthCoverageWaitingDelayLabel =
    getBusinessHealthCoverageWaitingDelayLabel;

  constructor(
    proposalService: ProposalService,
    private readonly router: Router
  ) {
    super(proposalService);
  }

  @Input()
  userId: string;

  viewCollaborator(collaboratorId: string): void {
    if (this.userId) {
      this.router.navigate([
        '/customers/view/collaborator',
        this.userId,
        collaboratorId,
      ]);
    }
  }

  // Helper methods to check if objects are empty
  isCoveragesEmpty(coverages: any): boolean {
    if (!coverages) return true;
    return Object.values(coverages).every(
      (value) =>
        value === null ||
        value === undefined ||
        value === false ||
        (Array.isArray(value) && value.length === 0) ||
        value === '' ||
        (typeof value === 'number' && value === 0)
    );
  }

  isSupplementaryCoveragesEmpty(supplementaryCoverages: any): boolean {
    if (!supplementaryCoverages) return true;
    return Object.values(supplementaryCoverages).every(
      (value) =>
        value === null || value === undefined || value === false || value === ''
    );
  }

  isContractInfoEmpty(metadata?: BusinessHealthMetadata): boolean {
    if (!metadata) return true;
    return (
      !metadata.startDate &&
      !metadata.contractDuration &&
      !metadata.paymentFrequency &&
      (metadata.splitPaymentFee === null ||
        metadata.splitPaymentFee === undefined)
    );
  }

  isInsuredPersonsEmpty(insuredPersons: any[] | undefined): boolean {
    return !insuredPersons || insuredPersons.length === 0;
  }

  isIjmInfoEmpty(metadata?: BusinessHealthMetadata): boolean {
    if (!metadata) return true;
    return (
      metadata.menTotalSalary === undefined &&
      metadata.womenTotalSalary === undefined &&
      metadata.waitingDays === undefined &&
      metadata.coveragePercent === undefined &&
      metadata.menCount === undefined &&
      metadata.menAverageAge === undefined &&
      metadata.womenCount === undefined &&
      metadata.womenAverageAge === undefined
    );
  }

  isCurrentInsuranceEmpty(metadata?: BusinessHealthMetadata): boolean {
    if (!metadata) return true;
    return (
      (metadata.hasInsurance === null || metadata.hasInsurance === undefined) &&
      !metadata.currentInsurer &&
      (metadata.hasClaimsLastFiveYears === null ||
        metadata.hasClaimsLastFiveYears === undefined)
    );
  }
}
